export enum TextDelimiter {
    PLACEHOLDER = '|'
}
